export default "__VITE_ASSET__BcXhSJBm__"